// ThemeContext.js
import React, { createContext, useContext } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const CustomThemeProvider = ({ children }) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#5C0E07',
      },
      secondary: {
        main: '#C05556',
      }, 
      text: {
        primary: '#000000',
        secondary: '#757575', 
        disabled: '#bdbdbd', 
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', // Font family
    },
  });

  return (
    <ThemeContext.Provider value={theme}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};